const selectLastChatDebugTurn = (state) => state.chatDebug.lastTurn;
export default selectLastChatDebugTurn;
